"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildQuery = void 0;
var query = require("query-string");
function buildQuery(locale, spaces, transformer) {
  return query.stringify(transformer(locale, spaces));
}
exports.buildQuery = buildQuery;